<template>
<div>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <div v-if="this.active != 1" class="mb-2">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item v-if="this.active < 3"> <a href="" @click.prevent="previous">List</a></el-breadcrumb-item>
                    <el-breadcrumb-item>View</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-form v-if="active === 1"> 
                <form
                v-if="company_id == userRole.company_id"
                class="mb-0"
                :class="{ 'loading-opacity': preloader }"
                ref="form"
                :data-url="addurl">

                <div class="row">
                    <div class="col-md-6 col-6">
                        <label for="inputs_form_id">
                            {{ $t("select_questionnaires") }}
                        </label>
                        <app-input
                            id="inputs_form_id"
                            type="multi-select"
                            :placeholder="$t('select_questionnaires')"
                            :list="questionnaire"
                            v-model="forms"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <button
                        type="button"
                        class="btn btn-primary mr-2 mt-2"
                        data-dismiss="modal"
                        @click.prevent="submit">
                            {{ $t("submit") }}
                        </button>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-12">
                    <app-table
                        :id="tableId"
                        :options="options"
                        @action="getListAction"
                        />
                </div>
            </div>

            </el-form>
            <el-form v-if="active === 2">
                <form-preview :id="form_body_id" :response="response" :userId="user_id" :form_id="form_id" :form_revision_id="form_revision_id" :taskId="task_id" :active="{ active }"></form-preview>
            </el-form>
        </div>        
    </div>
</div>
  <!--Delete Modal-->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="task-delete"
      @confirmed="confirmed"
      @cancelled="canceled"
    />
</div>
  
</template>

<script>
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import {GET_ATTACH_DOCUMENT,ATTACH_QUESTIONNAIRE_FORMS,TASK_ATTACH_QUESTIONNAIRE,GET_TASK_ATTACH_QUESTIONNAIRE, SHOW_TASK_ATTACH_QUESTIONNAIRE} from "../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosGet,
} from "../../../../Helpers/AxiosHelper";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [ModalMixin, FormMixin, TableHelpers],
  data() {
    return {
        form_body_id: 0,
        form_id: 0,
        form_revision_id: 0,
        task_id: 0,
        user_id: 0,
        response: '',
        company_id: 0,
        forms: [],

      active: 1,
      addurl: TASK_ATTACH_QUESTIONNAIRE,
      questionnaire: [],
      attach_documents: [],
      inputs: {},
      tableId: "advance-table",
      rowData: {},
      deleteLoader: false,
      deleteConfirmationModalActive: false,
      deletedDocId: 0,
      assign_user_id: 0,
      options: {
        name: "AdvanceTable",
        url: GET_TASK_ATTACH_QUESTIONNAIRE,
        showHeader: true,
        columns: [
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "get_forms",
            modifier: (value) => {
              return `<span>${this.$t(value.name)}</span>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "get_forms",
            modifier: (value) => {
              return `<span>${this.$t(value.description ?? '---')}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        // filters: [
        //   {
        //       "title": this.$t('date'),
        //       "type": "range-picker",
        //       "key": "date",
        //       "option": ["today", "thisMonth", "last7Days", "nextYear"]
        //   },
        //   {
        //       "title": this.$t('age'),
        //       "type": "range-filter",
        //       "key": "age-range",
        //       "maxTitle": this.$t('max_age'),
        //       "minTitle": this.$t('min_age'),
        //       "sign": ""
        //   },
        //   {
        //       "title": this.$t('status'),
        //       "type": "checkbox",
        //       "key": "status",
        //       "option": [
        //           {id: 'active', value: 'Active'},
        //           {id: 'inactive', value: 'Inactive'},
        //           {id: 'invited', value: 'Invited'},
        //       ],
        //   },
        //   {
        //       "title": this.$t('gender'),
        //       "type": "radio",
        //       "key": "filter-with-gender",
        //       "option": [
        //           {id: 'male', value: 'Male'},
        //           {id: 'female', value: 'Female'},
        //           {id: 'other', value: 'Other'},
        //       ],
        //       "header": {
        //           "title": this.$t('want_to_filter_your_list'),
        //           "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
        //       },
        //   },
        //   {
        //       "title": this.$t('search_and_select'),
        //       "type": "drop-down-filter",
        //       "key": "search select",
        //       "option": [],
        //   }
        // ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    submit() {

      // console.log(this.forms);

      if (this.forms.length == 0) {
          this.$toastr.e('Select Questionnaire First');
      }
      else {
        this.inputs.task_id = this.$attrs["props"].id;
        this.inputs.form_id = this.forms;

        let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
            formData.append(key,this.inputs[key]);
        });
      //   // console.log(formData);
        this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
    //   this.inputs = {};
      this.$hub.$emit("reload-" + this.tableId);
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        //   alert(rowData.id);
            this.form_body_id = rowData.form_body_id;
            this.form_id = rowData.form_id;
            this.form_revision_id = rowData.id;
            this.task_id = rowData.task_id;
            this.active = 2;
            this.user_id = rowData.created_by;
            this.response = 'save_response';
      }
    },

    getDocument() {
      let id = this.$attrs["props"];//ATTACH_QUESTIONNAIRE_FORMS
      axiosGet(GET_ATTACH_DOCUMENT)
        .then((res) => {
          this.questionnaire = res.data;
        })
        .catch((error) => {
          
        });
    },
    getAttachedQuestionnaire() {
      let id = this.$attrs["props"].id;
      this.options.url = this.options.url + '/' + id;
      axiosGet(SHOW_TASK_ATTACH_QUESTIONNAIRE + '/' + id)
        .then((res) => {
          console.log(res.data.forms);
          this.forms = res.data.forms;
          this.company_id = res.data.company_id;
        })
        .catch((error) => {
          
        });
    },
    previous() {
        this.active = 1;
    },
    removeFile(doc_id) {
      this.deletedDocId = doc_id;
      this.deleteConfirmationModalActive = true;
    },
    confirmed() {
      this.deleteLoader = true;
      let task_id = this.$attrs["props"].id;
      let deleteUrl = TASK_ATTACH_DOCUMENT_DELETE+'/'+this.deletedDocId+'?task_id='+task_id;
      this.axiosDelete(deleteUrl)
        .then((res) => {
          this.hideDeleteModal();
          this.$toastr.s(res.data.message);
          this.getAttachedDocument();
        })
        .catch((err) => {
          this.hideDeleteModal();
          this.$toastr.e(err.data.message);
        });
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
    canceled() {
      this.deletedTaskId = null;
      this.deleteConfirmationModalActive = false;
    },
  }, 
  mounted() {
    this.getDocument();
    this.getAttachedQuestionnaire();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
